// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import jssdk from "weixin-js-sdk"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import { Message, Loading } from 'element-ui'
import 'lib-flexible/flexible.js'
import 'video.js/dist/video-js.css'
import Video from 'video.js';
Vue.prototype.$video = Video;

import { compareTime } from './utils/compareTime.js'
Vue.prototype.$Time = compareTime

import store from './store';
// import './rem'
Vue.config.productionTip = false
Vue.prototype.$wx = jssdk
// 两秒内不可重复点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 30000)
      }
    })
  }
});


//这里设置路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { //判断是否需要登录验证
    var num = localStorage.getItem("token"); //这里是登录页面缓存
    // console.log(num)
    if (num) { //判断token等于时候就跳转路由
      next();//这个跳转是上面路由跳转
    } else { //token不一样时候就返回登录页面
      next({
        path: '/Public/Signin',//返回登录界面
        query: { redirect: from }  
      })
    }
  }
  else {
    //如果不需要登录权限就直接跳转到该路由
    // console.log(to)
    // if (to.path == '/Public/Award'){
    //   Message({
    //     message: '大赛结果未出，敬请期待！',
    //     duration: 3 * 1000
    //   })
    //   return
    // }
    next();
  }
})


// let loadingInstance = null //这里是loading
//   // 添加请求拦截器
// axios.interceptors.request.use(function (config) {
//   // 在发送请求之前做些什么
//   loadingInstance = Loading.service({
//     lock: true,
//     text: 'loading...'
//   })
//   return config;
// }, function (error) {
//   // 对请求错误做些什么
//   return Promise.reject(error);
// })



// // 添加响应拦截器
// axios.interceptors.response.use(function (response) {
//   // 对响应数据做点什么
//   console.log(response)
//   loadingInstance.close()
//   if (response.data.err_code == 0){
//     return response.data.data
//   }else{
//     // console.log(response.data.msg)
//     var zz = Message({
//       message: response.data.msg,
//       type: 'error',
//       duration: 3 * 1000
//     })
//     return zz;
//   }
  
// }, function (error) {
//   console.log(error)
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js